import styled from 'styled-components';
import { animated } from 'react-spring';
import { COLORS } from '../../styles/variables';

export const ShowFiltersCTA = styled(animated.button)<{ $ishovered: boolean; $scrolled: boolean }>`
  background: inherit;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border: none;
  padding: 0;
  width: 56px;
  height: 100px;
  position: ${({ $scrolled }) => ($scrolled ? 'fixed' : 'absolute')};
  background: ${({ $ishovered }) => ($ishovered ? COLORS.grey30 : COLORS.white)};
  left: 0;
  top: ${({ $scrolled }) => ($scrolled ? '40px' : '12px')};
  cursor: pointer;
  transition: background ease-in-out 0.3s;
  z-index: 10;
`;

export const Label = styled(animated.div)`
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.002px;
`;
